export default "__VITE_ASSET__DkYFTurC__"